module.exports = __webpack_public_path__ + "img/aggrid_stock.ec81e336.jpg";